module.exports = __webpack_public_path__ + "img/bg-customs.d229ccef.jpg";